import { MutationTree } from "vuex";
import { ProfileState } from "./types";
import { Gender } from "@dcc/types/gender";

export const mutationNames = {
  PROFILE_SETAGE: "profileSetAge",
  PROFILE_SETGENDER: "profileSetGender",
  PROFILE_SETPOSTCODE: "profileSetPostcode"
};

export const mutations: MutationTree<ProfileState> = {
  [mutationNames.PROFILE_SETAGE](state, payload: number) {
    state.age = payload;
  },

  [mutationNames.PROFILE_SETGENDER](state, payload: Gender) {
    state.gender = payload;
  },

  [mutationNames.PROFILE_SETPOSTCODE](state, payload: string) {
    state.postcode = payload;
  }
};
